import * as components from './components';

export default [
    {
        path: '/service-tickets/:status?',
        component: components.ServiceTicketList,
        name: 'serviceTicketList',
        meta: { admin: true }
    },
    {
        path: '/service-tickets/email/:ticketId?',
        component: components.ServiceTicketListFromEmail,
        name: 'serviceTicketListFromEmail'
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/servicetickets/routes.js